import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../../shared/makeApiCall";

import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function AddProductScreenViewModel(logout, addSnackbar, onNavigate) {
  const [loading, setLoading] = useState(false);

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [inventoryTypeOptions, setInventoryTypeOptions] = useState([]);
  const [classTypeOptions, setClassTypeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [boxTypeOptions, setBoxTypeOptions] = useState([]);
  const [graphicsOptions, setGraphicsOptions] = useState([]);
  const [allergenOptions, setAllergenOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [warehouseLocationsOptions, setWarehouseLocationsOptions] = useState(
    [],
  );
  const [productColours, setProductColours] = useState([]);
  const [productOdours, setProductOdours] = useState([]);
  const [productTastes, setProductTastes] = useState([]);

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getInventoryTypes = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall("inventoryTypesForDropdown");
    setLoading(false);
    if (callResult.success) {
      setInventoryTypeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch inventory types");
    }
  };

  const getClassTypes = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall("classesForDropdown");
    setLoading(false);
    if (callResult.success) {
      setClassTypeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch class types");
    }
  };

  const getCategoryTypes = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall("categoriesForDropdown");
    setLoading(false);
    if (callResult.success) {
      setCategoryOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch category types");
    }
  };

  const getBoxTypes = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall("boxTypesForDropdown");
    setLoading(false);
    if (callResult.success) {
      setBoxTypeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch box types");
    }
  };

  const getAllergens = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall("allergensForDropdown");
    setLoading(false);
    if (callResult.success) {
      setAllergenOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch allergens");
    }
  };

  const getWarehouses = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall("warehousesForDropdown");
    setLoading(false);
    if (callResult.success) {
      setWarehouseOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch warehouses");
    }
  };

  const getWarehouseLocations = async function (warehouseId) {
    setLoading(true);
    let callResult = await makeGetApiCall(
      `warehouseLocationsForDropdown/${warehouseId}`,
    );
    setLoading(false);
    if (callResult.success) {
      setWarehouseLocationsOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch warehouse locations");
    }
  };

  const getGraphics = async function (warehouseId) {
    setLoading(true);
    let callResult = await makeGetApiCall(`graphicsForDropdown`);
    setLoading(false);
    if (callResult.success) {
      setGraphicsOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch graphics");
    }
  };

  const createProduct = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall(
      "products/create",
      payload,
      "multipart/form-data",
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Product added",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      onNavigate(`/products/${callResult.data.id}`);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message || "Could not create product");
    }
  };

  const getProductColours = async function () {
    let callResult = await makeGetApiCall("productColoursForDropdown");
    if (callResult.success) {
      setProductColours(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch inventory types");
    }
  };

  const getProductOdours = async function () {
    let callResult = await makeGetApiCall("productOdoursForDropdown");
    if (callResult.success) {
      setProductOdours(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch inventory types");
    }
  };

  const getProductTastes = async function () {
    let callResult = await makeGetApiCall("productTastesForDropdown");
    if (callResult.success) {
      setProductTastes(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch inventory types");
    }
  };

  return {
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    inventoryTypeOptions,
    getInventoryTypes,
    classTypeOptions,
    categoryOptions,
    boxTypeOptions,
    allergenOptions,
    warehouseOptions,
    warehouseLocationsOptions,
    getClassTypes,
    getCategoryTypes,
    getBoxTypes,
    getAllergens,
    getWarehouses,
    getWarehouseLocations,
    createProduct,
    graphicsOptions,
    getGraphics,
    getProductColours,
    getProductOdours,
    getProductTastes,
    productColours,
    productOdours,
    productTastes,
  };
}
